<!-- Ported from the Polaris kit: src/product/components/RowMenu.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs;
     strings moved to i18n by hand. Change the design in the kit first. -->
<script setup>
// The three dots at the end of a card or a row: the few things you can do to it, in words. The button says whose menu it is.
import { OverflowMenuVertical16 } from '@carbon/icons-vue';
import { Button } from '../ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';

defineProps({
  label: { type: String, required: true }, // "Actions for Support agent"
  items: { type: Array, required: true }, // [{ label, value, icon?, destructive? }]
});
const emit = defineEmits(['action']);
</script>

<template>
  <DropdownMenu>
    <DropdownMenuTrigger as-child>
      <Button type="button" variant="ghost" size="icon-sm" :aria-label="label">
        <OverflowMenuVertical16 aria-hidden="true" />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end">
      <template v-for="(item, at) in items" :key="item.value">
        <DropdownMenuSeparator v-if="item.destructive && at" />
        <DropdownMenuItem
          :variant="item.destructive ? 'destructive' : 'default'"
          @select="emit('action', item.value)"
        >
          <component :is="item.icon" v-if="item.icon" aria-hidden="true" />{{
            item.label
          }}
        </DropdownMenuItem>
      </template>
    </DropdownMenuContent>
  </DropdownMenu>
</template>
